import React from 'react';

const svgBase = {
  viewBox: '0 0 24 24',
  fill: 'none',
  'aria-hidden': true,
  focusable: false,
};

function StrokeG({ children }) {
  return (
    <g stroke="currentColor" strokeWidth="1.65" strokeLinecap="round" strokeLinejoin="round">
      {children}
    </g>
  );
}

/** Nadchodzące — zegar (zamiast 📅 obok kalendarza w linku). */
export function ProfileStatClockIcon({ size = 20, className = 'p-dash-stat-icon-svg' }) {
  return (
    <svg {...svgBase} className={className} width={size} height={size}>
      <StrokeG>
        <circle cx="12" cy="12" r="8" />
        <path d="M12 8v4l3 2" />
      </StrokeG>
    </svg>
  );
}

export function ProfileStatCheckCircleIcon({ size = 20, className = 'p-dash-stat-icon-svg' }) {
  return (
    <svg {...svgBase} className={className} width={size} height={size}>
      <StrokeG>
        <circle cx="12" cy="12" r="8" />
        <path d="M9 12l2 2 4-4" />
      </StrokeG>
    </svg>
  );
}

export function ProfileStatMegaphoneIcon({ size = 20, className = 'p-dash-stat-icon-svg' }) {
  return (
    <svg {...svgBase} className={className} width={size} height={size}>
      <StrokeG>
        <path d="M4 11v2a1 1 0 0 0 1 1h2l4 3V7L7 10H5a1 1 0 0 0-1 1z" />
        <path d="M18 8a4 4 0 0 1 0 8" />
        <line x1="15" y1="10" x2="15" y2="14" />
      </StrokeG>
    </svg>
  );
}

export function ProfileStatUsersIcon({ size = 20, className = 'p-dash-stat-icon-svg' }) {
  return (
    <svg {...svgBase} className={className} width={size} height={size}>
      <StrokeG>
        <circle cx="8" cy="8" r="3.2" />
        <path d="M4 20.5v-.5a4 4 0 0 1 8 0v.5" />
        <circle cx="17" cy="8" r="3.2" />
        <path d="M13 20.5v-.5a4 4 0 0 1 8 0v.5" />
      </StrokeG>
    </svg>
  );
}

export function ProfileStatGlobeIcon({ size = 20, className = 'p-dash-stat-icon-svg' }) {
  return (
    <svg {...svgBase} className={className} width={size} height={size}>
      <StrokeG>
        <circle cx="12" cy="12" r="8" />
        <path d="M4 12h16" />
        <path d="M12 4c-2.8 3.2-2.8 12.8 0 16M12 4c2.8 3.2 2.8 12.8 0 16" />
      </StrokeG>
    </svg>
  );
}

export function ProfileSpotlightHeartIcon({ size = 22, className = 'p-dash-spotlight-icon-svg' }) {
  return (
    <svg {...svgBase} className={className} width={size} height={size}>
      <path
        d="M12 21s-7-4.35-7-10a4 4 0 0 1 7-1 4 4 0 0 1 7 1c0 5.65-7 10-7 10z"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.65"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

/** Link „Zobacz odznaki…” — kalendarz (odpowiednik 📅). */
export function ProfileAchievementsCalendarLinkIcon({
  size = 18,
  className = 'profile-achievements-link-icon-svg',
}) {
  return (
    <svg {...svgBase} className={className} width={size} height={size}>
      <StrokeG>
        <rect x="4" y="5" width="16" height="15" rx="2" />
        <line x1="4" y1="11" x2="20" y2="11" />
        <line x1="8" y1="3" x2="8" y2="7" />
        <line x1="16" y1="3" x2="16" y2="7" />
      </StrokeG>
    </svg>
  );
}

/** Nagłówek karty „Twój plan” — odpowiednik ✨ (iskry, obrys jak w reszcie profilu). */
export function ProfilePlanSparklesIcon({ size = 20, className = 'apw-header-icon-svg' }) {
  return (
    <svg {...svgBase} className={className} width={size} height={size}>
      <StrokeG>
        <path d="M12 4v4M12 16v4M4 12h4M16 12h4" />
        <path d="M6.5 6.5l2.5 2.5M17.5 17.5l-2.5-2.5M17.5 6.5l-2.5 2.5M6.5 17.5l2.5-2.5" />
      </StrokeG>
    </svg>
  );
}

/** Status „Znajomi” / przycisk akceptacji — okrągły ptaszek. */
export function ProfileFriendsStatusCheckIcon({
  size = 18,
  className = 'profile-popup-friend-inline-icon',
}) {
  return (
    <svg {...svgBase} className={className} width={size} height={size}>
      <StrokeG>
        <circle cx="12" cy="12" r="8" />
        <path d="M9 12l2 2 4-4" />
      </StrokeG>
    </svg>
  );
}

/** Usuń ze znajomych — kosz. */
export function ProfileFriendsRemoveTrashIcon({
  size = 18,
  className = 'profile-popup-friend-inline-icon',
}) {
  return (
    <svg {...svgBase} className={className} width={size} height={size}>
      <StrokeG>
        <path d="M9 9v8M15 9v8" />
        <path d="M5 7h14l-1 12a1 1 0 0 1-1 .9H7a1 1 0 0 1-1-.9L5 7zM10 7V5a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v2" />
        <path d="M4 7h16" />
      </StrokeG>
    </svg>
  );
}

/** Pinezka / miasto w popupie profilu. */
export function ProfileCardMapPinIcon({ size = 16, className = 'profile-popup-info-icon-svg' }) {
  return (
    <svg {...svgBase} className={className} width={size} height={size}>
      <StrokeG>
        <path d="M12 21s-5.2-4.2-5.2-9.2a5.2 5.2 0 1 1 10.4 0C17.2 16.8 12 21 12 21z" />
        <circle cx="12" cy="11.5" r="2" />
      </StrokeG>
    </svg>
  );
}

/** Wiek — tort (zamiast tarczy). */
export function ProfileCardCakeIcon({ size = 16, className = 'profile-popup-info-icon-svg' }) {
  return (
    <svg {...svgBase} className={className} width={size} height={size}>
      <StrokeG>
        <path d="M6 20h12v-3.5H6V20z" />
        <path d="M8 16.5V11l4-1.8 4 1.8v5.5" />
        <path d="M7 11h10" />
        <path d="M12 9V5.5M10.5 5.5h3" />
        <path d="M9 14h1.2v1.2H9zM11.4 14h1.2v1.2h-1.2zM13.8 14H15v1.2h-1.2z" />
      </StrokeG>
    </svg>
  );
}

/** Zaproszenie do znajomych. */
export function ProfileCardUserPlusIcon({ size = 18, className = 'profile-popup-friend-inline-icon' }) {
  return (
    <svg {...svgBase} className={className} width={size} height={size}>
      <StrokeG>
        <circle cx="9" cy="8" r="3" />
        <path d="M4 19.5v-.3a5 5 0 0 1 5-5" />
        <path d="M17 11v6M14 14h6" />
      </StrokeG>
    </svg>
  );
}

/** Oczekiwanie na odpowiedź. */
export function ProfileCardHourglassIcon({ size = 18, className = 'profile-popup-friend-inline-icon' }) {
  return (
    <svg {...svgBase} className={className} width={size} height={size}>
      <StrokeG>
        <path d="M8 3h8v3l-4 4.5 4 4.5v3H8v-3l4-4.5L8 6V3z" />
        <path d="M8 12h8" />
      </StrokeG>
    </svg>
  );
}

export function ProfileCardXIcon({ size = 18, className = 'profile-popup-friend-inline-icon' }) {
  return (
    <svg {...svgBase} className={className} width={size} height={size}>
      <StrokeG>
        <path d="M7 7l10 10M17 7L7 17" />
      </StrokeG>
    </svg>
  );
}

/** Symbol płci męskiej (Mars). */
export function ProfileGenderMaleIcon({ size = 16, className = 'profile-popup-gender-icon-svg' }) {
  return (
    <svg {...svgBase} className={className} width={size} height={size}>
      <StrokeG>
        <circle cx="9" cy="15" r="4" />
        <path d="M12 12l6-6" />
        <path d="M14.5 6H18v3.5" />
      </StrokeG>
    </svg>
  );
}

/** Symbol płci żeńskiej (Venus). */
export function ProfileGenderFemaleIcon({ size = 16, className = 'profile-popup-gender-icon-svg' }) {
  return (
    <svg {...svgBase} className={className} width={size} height={size}>
      <StrokeG>
        <circle cx="12" cy="9" r="4" />
        <path d="M12 13v6" />
        <path d="M9.5 16.5h5" />
      </StrokeG>
    </svg>
  );
}

const STAT_ICON_BY_ID = {
  upcoming: ProfileStatClockIcon,
  completed: ProfileStatCheckCircleIcon,
  organized: ProfileStatMegaphoneIcon,
  friends: ProfileStatUsersIcon,
  places: ProfileStatGlobeIcon,
};

export function ProfileStatTileIcon({ tileId, size = 45 }) {
  const Cmp = STAT_ICON_BY_ID[tileId];
  if (!Cmp) return null;
  return <Cmp size={size} />;
}
